import "../App.css";
import "./styles/hero.css";
import HopperHacksText from "../images/HopperHacks 2024.png";
import HopperHacksLogo from "../images/Hopper Sleeping Main.png";
import Countdown from "./countdown";
import logo from "../images/WiCS Logo.png";
function Hero({
  refToAbout,
  refToSchedule,
  refToTracks,
  refToFAQ,
  refToSponsors,
}) {
  //#region scroll to different sections of the page functions
  const scrollToAbout = (e) => {
    e.preventDefault();
    refToAbout.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToSchedule = (e) => {
    e.preventDefault();
    refToSchedule.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToTracks = (e) => {
    e.preventDefault();
    refToTracks.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToFAQ = (e) => {
    e.preventDefault();
    refToFAQ.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToSponsors = (e) => {
    e.preventDefault();
    refToSponsors.current.scrollIntoView({ behavior: "smooth" });
  };
  //#endregion

  return (
    <div>
      <nav className="navbar navbar-dark navbar-expand-lg navigation-bar header-font d-flex justify-content-between fs-xs-5 fs-md-4 fs-lg-4 nav-bar-link user-select-none text-white">
        <div className="container-fluid">
          <a
            className="navbar-brand"
            href="https://www3.cs.stonybrook.edu/~wics/"
          >
            <img src={logo} alt="wics logo" style={{ width: "100px" }} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li
                className="nav-item dropdown navigation-bar"
                style={{ margin: "0px 1.1vw" }}
              >
                <a
                  className="nav-link text-decoration-none"
                  id="applyDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ color: 'white'}} // Add this line
                >
                  Apply
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="applyDropdown"
                  style={{ backgroundColor: "#2e3b84" }}
                >
                  <li>
                    <a
                      className="dropdown-item dropdown-item-color-wics-blue"
                      href="https://forms.gle/42sQCLHbjBxviGio9"
                      target="_blank"
                    >
                      Apply as Hacker
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item dropdown-item-color-wics-blue"
                      href="https://forms.gle/kcyCe8esRAYJEar7A"
                      target="_blank"
                    >
                      Apply as a Mentor
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item" style={{ margin: "0px 1.1vw" }}>
                <a className="nav-link" href="#" onClick={scrollToAbout}>
                  About
                </a>
              </li>
              <li className="nav-item" style={{ margin: "0px 1.1vw" }}>
                <a className="nav-link" href="#" onClick={scrollToSchedule}>
                  Schedule
                </a>
              </li>
              <li className="nav-item" style={{ margin: "0px 1.1vw" }}>
                <a className="nav-link" href="#" onClick={scrollToTracks}>
                  Tracks
                </a>
              </li>
              <li className="nav-item" style={{ margin: "0px 1.1vw" }}>
                <a className="nav-link" href="#" onClick={scrollToFAQ}>
                  FAQ
                </a>
              </li>
              <li className="nav-item" style={{ margin: "0px 1.1vw" }}>
                <a className="nav-link" href="#" onClick={scrollToSponsors}>
                  Sponsors
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <nav class="navigation-bar header-font d-flex justify-content-between fs-xs-5 fs-md-4 fs-lg-4 nav-bar-link user-select-none text-white">
        <div className="logo">
          <a href="https://www3.cs.stonybrook.edu/~wics/">
            <img src={logo} alt="wics logo" style={{ width: "100px" }} />
          </a>
        </div>
        <div className="d-flex">
          <div style={{ margin: "0px 1.1vw" }}>
            <a href="#" onClick={scrollToAbout} class="text-decoration-none">
              About
            </a>
          </div>
          <div style={{ margin: "0px 1.1vw" }}>
            <a href="#" onClick={scrollToSchedule} class="text-decoration-none">
              Schedule
            </a>
          </div>
          <div style={{ margin: "0px 1.1vw" }}>
            <a href="#" onClick={scrollToTracks} class="text-decoration-none">
              Tracks
            </a>
          </div>
          <div style={{ margin: "0px 1.1vw" }}>
            <a href="#" onClick={scrollToFAQ} class="text-decoration-none">
              FAQ
            </a>
          </div>
          <div style={{ margin: "0px 1.1vw" }}>
            <a href="#" onClick={scrollToSponsors} class="text-decoration-none">
              Sponsors
            </a>
          </div>
          <div className="dropdown" style={{ margin: "0px 1.1vw" }}>
            <a
              className="dropdown-toggle text-decoration-none"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Apply
            </a>
            <div
              className="dropdown-menu"
              style={{ backgroundColor: "#2e3b84" }}
              aria-labelledby="dropdownMenuLink"
            >
              <div
                className="dropdown-item dropdown-item-color-wics-blue"
                href="#link1"
              >
                <a
                  href="https://forms.gle/42sQCLHbjBxviGio9"
                  target="_blank"
                  className="text-decoration-none"
                >
                  Apply as Hacker
                </a>
              </div>
              <div
                className="dropdown-item dropdown-item-color-wics-blue"
                href="#link2"
              >
                <a
                  href="https://forms.gle/kcyCe8esRAYJEar7A"
                  target="=_blank"
                  className="text-decoration-none"
                >
                  Apply as a Mentor
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav> */}
      <div id="hero" className="position-relative p-5 text-center">
        <div className="position-relative" style={{ left: "0%" }}>
          <div className="d-flex justify-content-center align-items-center">
            <div className="position-relative">
              <img
                src={HopperHacksLogo}
                alt="HopperHacks Logo"
                className=""
                style={{ width: "90%" }}
              />
            </div>
            <div className="position-relative" style={{ left: "-20%" }}>
              <img
                src={HopperHacksText}
                alt="HopperHacks 2024"
                className="img-fluid"
                style={{
                  width: "90%",
                }}
              />
            </div>
          </div>

          <div
            className="w-100 position-absolute text-white"
            style={{ top: "80%" }}
          >
            <h5 className="pb-4">Febuary 3rd, 2024</h5>
            <div className="" id="countdown">
              <h1>Time Till Slumber Party</h1>
              <h1>
                <Countdown />{" "}
              </h1>
            </div>
          </div>
        </div>

        <div
          className="position-absolute star"
          style={{
            left: 0,
            top: 0,
            zIndex: -1,
          }}
        ></div>

        <div className="position-absolute" style={{ top: 0 }}>
          <div className="stars-1"></div>
          <div className="stars-2"></div>
        </div>
      </div>
    </div>
  );
  // return (
  //     <>
  //       <nav class="navigation-bar header-font d-flex fs-xs-5 fs-md-4 fs-lg-4 nav-bar-link user-select-none position-absolute text-white" style={{ right: "2vw" }}>
  //         <div style={{margin: "0px 1.1vw" }}>
  //           <a href="#" onClick={scrollToAbout} class="text-decoration-none">About</a>
  //         </div>
  //         <div style={{margin: "0px 1.1vw" }}>
  //           <a href="#" onClick={scrollToSchedule} class="text-decoration-none">Schedule</a>
  //         </div>
  //         <div style={{margin: "0px 1.1vw" }}>
  //           <a href="#" onClick={scrollToTracks} class="text-decoration-none">Tracks</a>
  //         </div>
  //         <div style={{margin: "0px 1.1vw" }}>
  //           <a href="#" onClick={scrollToFAQ} class="text-decoration-none">FAQ</a>
  //         </div>
  //         <div style={{ margin: "0px 1.1vw" }}>
  //           <a href="#" onClick={scrollToSponsors} class="text-decoration-none">Sponsors</a>
  //         </div>
  //         <div style={{margin: "0px 1.1vw" }}>
  //           <a href="#" class="text-decoration-none">Apply</a>
  //         </div>
  //       </nav>
  //       <div id="herobackground">
  //         <img src={heroimg} style={{ width: "100%" }} />
  //       </div>
  //     </>
  //   );
}

export default Hero;
